import { Button, Checkbox, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import MainCard from '../../components/ui-component/card/MainCard'
import SearchTextFieldComp from '../../newComponent/newtextfieldComp/SearchTextFieldComp'
import { DataGrid } from '@mui/x-data-grid'
import CustomNoRowsOverlay from '../../newComponent/TableCustomeComp/CustomNoRowsOverlay'
import { fDateTime } from '../../../utils/formatTime'
import CustomPopup from '../../../components/CustomPopup'
import EditMissedLeadsForm from './EditMissedLeadsForm'
import EditIconcomp from '../../newComponent/iconsComp/EditIconcomp'

export default function MissedAutoAssignOtherLeads({ setSelectedid,registerdata,setRegisterdate,selectedid ,originalData , andelclose , handelopen}) {

  const [selectedData, setSelectedData] = useState([]);
    const [openEditPopup, setOpenEditPopup] = useState(false);

//select one checkbox
  const handleCheckboxChange = (event, id) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedid([...selectedid, id]);
    } else {
      setSelectedid(selectedid.filter((selectedId) => selectedId !== id));
    }
  };
      // search all column in datagrid
      const handleSearchByName = (e) => {
        const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)
    
        let filteredData1 = originalData.filter((data) => {
          // Check each field for a match with the search value
          const fieldsToSearch = [
            `${data.first_name || ""}
              ${data.last_name || ""}`,
         
    
            `${data?.mobile_country_code  || ""} ${data?.mobile  || ""}`,
            `${data?.service_id?.service_name}`,
            `${data?.sub_service_id?.name}`,
            `${data?.nearest_branch_id?.branch_name}`,
            `${data?.assign_to?.first_name || ""} ${data?.assign_to?.last_name}`,
            `${data?.enquiry_id?.stage_id?.stage_name}`,
            `${data?.email || ""}`,
            `${data?.lead_source_type_id?.name || ""}`,
            `${data?.sub_lead_source_type_id?.source_type}`,
            `${data?.campaign_id?.campaign_name}`,
            `${ fDateTime (data?.createdAt)}`,
          ];
    
          // Check if any of the fields contain the search value
          return fieldsToSearch.some((field) =>
            field.toLowerCase().replace(/\s+/g, "").includes(value)
          );
        });
    
        setRegisterdate(filteredData1); // Update the filtered data
      };

 const columns = [
    {
      field: "selection",
      headerName: "Select",
      width: 50,
      sortable:false,
      disableColumnMenu:true,
      renderCell: (params) => {
        return (
          <>
            <Checkbox
              size="small"
              type="checkbox"
              onChange={(event) => handleCheckboxChange(event, params.row.id)}
              checked={selectedid.includes(params.row.id)}
            />
          </>
        );
      },
    },
    
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable:false,
      disableColumnMenu:true,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              style={{
              fontSize:'0.55rem',
                borderRadius: "24px",
                background: "#46b1ff",
                height: "20px",
              }}
              onClick={() => handelopen(params.row.id)}
            >
              Assign To Advisor
            </Button>
          
            <EditIconcomp  onClick={() => handleEditOpen(params.row)} tooltipTitle="Edit"/>
            
       
          </div>
        );
      },
    },

    {
      field: "name",
      headerName: "Name",
      width: 150,
      valueGetter: (params) => `${params.row?.first_name || ""} ${params.row?.last_name || ""}`,
      renderCell: (params) => (
        <Typography>
          {params.row?.first_name} {params.row?.last_name}
        </Typography>
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      valueGetter: (params) => ` ${params.row?.mobile_country_code} ${params.row?.mobile || ""}`,
      renderCell: (params) => (
        <Typography>
          {params.row?.mobile_country_code}
          {params.row?.mobile}
        </Typography>
      ),
    },
    {
      field: "email",
      headerName: "Email ID",
      width: 220,
    
    },
    {
      field: "enquired_service",
      headerName: "Enquired Service",
      width: 150,
      valueGetter: (params) => `${params.row?.service_id?.service_name || ""}`,
      renderCell: (params) => (
        <Typography>{params.row.service_id?.service_name}</Typography>
      ),
    },

    {
      field: "sub_service_id",
      headerName: "Sub Service",
      width: 150,
      valueGetter: (params) => `${params.row?.sub_service_id?.name || ""}`,
      renderCell: (params) => (
        <Typography>{params.row.sub_service_id?.name}</Typography>
      ),
    },
    {
      field: "branch_id",
      headerName: "STM Nearest Branch",
      width: 200,
      valueGetter: (params) => `${params.row?.nearest_branch_id?.branch_name || ""}`,
      renderCell: (params) => (
        <Typography>{params.row.nearest_branch_id?.branch_name} </Typography>
      ),
    },
    {
      field: "permanent_assignee",
      headerName: "Permanent Assignee",
      width: 150,
      valueGetter: (params) => `${params.row?.assign_to?.first_name || ""} ${params.row?.assign_to?.last_name || ""}`, 
      renderCell: (params) => (
        <Typography>{params.row.assign_to?.first_name}  {params.row.assign_to?.last_name}</Typography>
      ),
    },



    {
      field: "lead_source_type_id",
      headerName: "Lead Source",
      width: 150,
      valueGetter: (params) => `${params.row?.lead_source_type_id?.name || ""}`,
      renderCell: (params) => (
        <Typography>{params.row.lead_source_type_id?.name} </Typography>
      ),
    },
    {
      field: "sub_lead_source_type_name",
      headerName: "Sub Lead Source",
      width: 150,
      valueGetter: (params) => `${params.row?.sub_lead_source_type_id?.source_type || ""}`,
      renderCell: (params) => (
        <Typography>
          {params.row?.sub_lead_source_type_id?.source_type}{" "}
        </Typography>
      ),
    },

    {
      field: "campaign_id",
      headerName: "Campaign",
      width: 150,
      valueGetter: (params) => `${params.row?.campaign_id?.campaign_name || ""}`,
      renderCell: (params) => (
        <Typography>{params.row?.campaign_id?.campaign_name} </Typography>
      ),
    },

    {
      field: "first_country",
      headerName: "First Country Of Interest",
      width: 150,
      valueGetter: (params) => `${params.row?.target_country_id?.country_name || ""}`,
      renderCell: (params) => (
        <Typography>{params.row.target_country_id?.country_name} </Typography>
      ),
    },

    {
      field: "created_time",
      headerName: "Created Time",
      width: 150,
      valueGetter: (params) => `${params.row?.createdAt || ""}`,
      renderCell: (params) => (
        <Typography>{fDateTime(params.row?.createdAt)} </Typography>
      ),
    },
  ];

   const handleEditOpen = (data) => {
    setSelectedData(data);
    setOpenEditPopup(true)
  }

  const handleEditClose = () => {
    setOpenEditPopup(false);
  }


  

  return (
 <>
 <Grid container>
      <Grid item xs={12}>
              
              <MainCard>
                <Grid container spacing={2}>
                  <Grid item xs={12} textAlign='end'>
                    <SearchTextFieldComp onChange={handleSearchByName}/>
                  </Grid>
                  <Grid item xs={12}>
                  <DataGrid
                    rows={registerdata}
                    columns={columns}
                    autoHeight
                     slots={{
                                        noRowsOverlay: CustomNoRowsOverlay,
                                      }}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 100,
                        },
                      },
                    }}
            
                    pageSizeOptions={[25, 50, 100]}
                  />
                  </Grid>
                </Grid>
              </MainCard>
            </Grid>
       
 </Grid>

  {/*Edit*/}
       <CustomPopup
               open={openEditPopup}
               onClose={handleEditClose}
               component={
                 <EditMissedLeadsForm
                   onClose={handleEditClose}
                   selectedRowData={selectedData}
                 />
               }
               title="Edit Missed Auto Assign Lead"
               maxWidth="sm"
               showDivider={true}
             />
 
 </>
  )
}
